var render = function render(){var _vm=this,_c=_vm._self._c;return _c('progress',{staticClass:"progress pure-material-progress-linear"})
}
var staticRenderFns = []

export { render, staticRenderFns }